import { Toaster as Sonner, toast } from "sonner";

const Toaster = (props) => (
  <Sonner
    theme="dark"
    className="toaster group"
    toastOptions={{
      classNames: {
        toast: "group toast group-[.toaster]:bg-zinc-900 group-[.toaster]:text-zinc-50 group-[.toaster]:border-white/10 group-[.toaster]:shadow-lg",
        description: "group-[.toast]:text-zinc-400",
        actionButton: "group-[.toast]:bg-amber-500 group-[.toast]:text-black",
        cancelButton: "group-[.toast]:bg-zinc-800 group-[.toast]:text-zinc-50",
      },
    }}
    {...props}
  />
);

export { Toaster, toast };
